module.exports = __webpack_public_path__ + "static/media/success.8473f5d0.png";